import { importsSalesforceStartPostSlice } from './post';

export const {
	requestPostImportsSalesforceStart,
	resetPostImportsSalesforceStart
} = importsSalesforceStartPostSlice.asyncActionCreators;
